const initialState = {
    userList: [],
    totalCount: 0,
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'USERS_LIST': {
            return {
                ...state,
                userList: action.payload.users,
                totalCount: action.payload.meta.totalCount || 0,
            };
        }
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

export default userReducer;